import { StorageState } from '../../../reducers';
import { createDataFetchSliceSelectors } from '../../../utils/dataFetch';


export const accountsWithBalanceAndChargesSliceSelector = (state: StorageState) => state.accounts.balanceAndCharges;

export const accountsWithBalanceAndChargesSelectors = createDataFetchSliceSelectors(
    accountsWithBalanceAndChargesSliceSelector
);
